export const en = {
    'ROLE_FILTER.LABEL': 'Filter roles',
    'ROLE_FILTER.SHOW_ALL': 'Show all roles',
    'ROLE_FILTER.ELEVATED': 'Elevated roles',
    'ROLE_FILTER.ROLE_COUNT': '{[{ count }]} roles',
    'ROLE_FILTER.SELECT_ALL': 'Select all roles',
    'ROLE_FILTER.SELECT_ELEVATED': 'Select elevated roles',
    'ROLE_FILTER.CLEAR': 'Clear selection',
    'ROLES.ADMIN': 'Admin',
    'ROLES.REPORTER': 'Reporter',
    'ROLES.VR_USER': 'VR User',
    'ROLES.EVENT_MANAGER': 'Event Manager',
    'ROLES.EVENT_CURATOR': 'Event Curator',
    'ROLES.BC_USER': 'BC User',
    'ROLES.BC_MANAGER': 'BC Manager',
    'ROLES.DA_USER': 'DA User',
    'ROLES.DA_MANAGER': 'DA Manager',
    'ROLES.LR_USER': 'LR User',
};
